import { render, staticRenderFns } from "./MySalesRevenue.vue?vue&type=template&id=4fbe4618&scoped=true&"
import script from "./MySalesRevenue.vue?vue&type=script&lang=js&"
export * from "./MySalesRevenue.vue?vue&type=script&lang=js&"
import style0 from "./MySalesRevenue.vue?vue&type=style&index=0&id=4fbe4618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe4618",
  null
  
)

component.options.__file = "MySalesRevenue.vue"
export default component.exports